import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { SIDEBAR } from '@core/constants/navigation';
import { NavigationItem } from '@core/models/navigation';
import { PermissionMap } from '@core/models/permission/permission';
import { environment } from '@environments/environment';
import { NgxPermissionsService } from 'ngx-permissions';

const FALLBACK_URL = '/settings/account-setting';

const PRIORITY_PATHS = ['crm', 'exploit'];

const PRIORITIZED_SIDEBAR: NavigationItem[] = [
  ...PRIORITY_PATHS.map(path => SIDEBAR.find(item => item.path === path)).filter((item): item is NavigationItem => !!item),
  ...SIDEBAR.filter(item => !PRIORITY_PATHS.includes(item.path))
];

function isVisible(item: NavigationItem, permissions: PermissionMap): boolean {
  if (item.environments && !item.environments.includes(environment.ENV)) {
    return false;
  }
  return !item.permissions?.length || item.permissions.some(p => p in permissions);
}

function findFirstVisiblePath(items: NavigationItem[], permissions: PermissionMap): string | null {
  for (const item of items) {
    if (!isVisible(item, permissions)) {
      continue;
    }

    if (!item.children?.length) {
      return item.path;
    }

    const childPath = findFirstVisiblePath(item.children, permissions);
    if (childPath) {
      return childPath;
    }
  }

  return null;
}

export const defaultRedirectGuard: CanActivateFn = (): UrlTree => {
  const router = inject(Router);
  const permissions: PermissionMap = inject(NgxPermissionsService).getPermissions();

  const path = findFirstVisiblePath(PRIORITIZED_SIDEBAR, permissions);
  return router.parseUrl(path ? `/${path}` : FALLBACK_URL);
};
